var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"responsive-table",class:{last: _vm.maxed}},[(_vm.$slots.header)?_c('thead',[_vm._t("header")],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }